<template>
  <div class="hot-box">
    <div class="hot-top">
      <div class="top-title">{{title}}</div>
      <!-- <div class="top-more">查看全部</div> -->
    </div>
    <div  :class="[isFlex?'hot-product':'hot-product1']">
      <img :class="[isFlex?'product-img':'product-img1']" v-for="(item, index) in hotList" :key="index" :src="getPhoto(item.picDef)" @click="goDetail(item)"/>
    </div>
  </div>
</template>
<script>
import global from 'global'
export default {
  name: 'hotBox',
  props: {
    hotList: {
      type: Array,
      required: true
    },
    isFlex: Boolean,
    title: {
      type: String,
      default: '近期新上产品'
    }
  },
  methods: {
    // 获取图片
    getPhoto (pics) {
      return global.file.url + '/sys/fs/' + pics + '?s=3'
    },
    goDetail (item) {
      this.$router.push({ path: '/product/' + item.sku })
    }
  }
}
</script>
<style lang="less" scoped>
.hot-box {
  box-shadow: 0 0 5px #e6e6e6;
  width: 590px;
  .hot-top {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    padding: 10px 10px;
    border-bottom: 1px solid #ccc;
    .top-title {
      border-left: 5px solid #9d88c4;
      font-weight: 700;
      font-size: 18px;
      padding-left: 5px;
    }
    .top-more {
      cursor: pointer;
    }
  }
  .hot-product {
    padding: 10px;
    display: flex;
    justify-content: space-around;
    .product-img {
      cursor: pointer;
      width: 130px;
      height: 130px;
      overflow: hidden;
      border-radius: 4px;
      box-shadow: 0 0 5px #ccc;
    }
  }
}

.hot-product1{
  display: block;
  padding: 10px;
  .product-img1 {
    cursor: pointer;
    width: 130px;
    height: 130px;
    overflow: hidden;
    border-radius: 4px;
    box-shadow: 0 0 5px #ccc;
    margin-left: 20px;
  }
}
</style>
